import React from 'react';
import { Planet } from 'react-planet';
import './MyPlanet.css'; // Importez votre fichier CSS


const Satellite = ({ id, href, label }) => {
  return (
    <a href={href}>
      <div className={`satellite satellite${id}`} >
        <span className="label">{label}</span>
      </div>
    </a>
  );
};

export function MyPlanet() {
  return (
    <div>
      
      <Planet
      centerContent={
        <div className="terre" /> 
      }
      /* orbitRadius éloignement du satellite*/
      orbitRadius={400}
      mass={4}
      tension={300}
      friction={19}
      close
      rotation={30}
      autoClose
    >
    <Satellite id="1" href="https://glass.sonel.org" label="SonelNode"  />
    <Satellite id="2" href="https://test.glass.sonel.org" label="Rinex Metadata -3"  />
    <Satellite id="5" href="https://semaphore.glass.sonel.org" label="Semaphore"  />
	  <Satellite id="6" href="https://gnssquality-epos.oma.be/rinex_data_availability/daily_availability.php?node=SNL_EUR" label="QualityCheck"  />
    <Satellite id="7" href="https://glass.sonel.org/GlassFramework/" label="Glass_API"  />
    <Satellite id="9" href="https://admin.glass.sonel.org/gnss-europe.html" label="schema_db"  />
    <Satellite id="b" href="http://m3g.glass.sonel.org/" label="tree" />
    
    </Planet>

    
  </div>
  );
}




